import { Message, MessageHeader } from 'semantic-ui-react';

import styles from './HelpMessageWidget.module.less';

// import alignTopSVG from './icons/align-top.svg';
// import alignBottomSVG from './icons/align-bottom.svg';
// import alignMiddleSVG from './icons/align-vertical-middle.svg';
// import alignCenterSVG from './icons/align-horizontal-middle.svg';
// import alignLeftSVG from './icons/align-left.svg';
// import alignRightSVG from './icons/align-right.svg';

// TODO: Inlcuir opções de ícone e abrir/fechar
const HelpMessageWidget = (props) => {
  const { title, body } = props;

  return (
    <Message color="teal" icon="inbox" size="small" className={styles.msg}>
      <MessageHeader>{title}</MessageHeader> <div>{body}</div>
    </Message>
  );
};

export default HelpMessageWidget;
